<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="hiring_area">Job Posts in Every City of Your Hiring Area</h2>
        <div class="flex justify-start mt-4 mb-8 lg:mb-16" v-if="proposal_document.minimap_url">
            <div class="shadow tr-box">
                <img :src="proposal_document.minimap_url" class="lg:w-hiringarea" alt="hiring area">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'proposal_document',
        'section',
    ],
}
</script>